import Dispatcher from './architecture/Dispatch'
import BaseComponent2 from './architecture/BaseComponent'
import Apollo from './architecture/apollo'
import URL2 from './modules/navigation/url'
import History2 from './architecture/history'
import Modal2 from './modules/modal/Modal'
import objectParser from './helpers/objectParser'
import bufferObject from './modules/misc/bufferObject'
import Ms from './modules/multiSelect/MultiSelect'
import Tb from './modules/textbox/Textbox'
import { Request as Request2 } from '../backend/index'
import SubmitButton2 from './modules/SubmitButton'
import Select2 from './modules/select/Select'

export const Dispatch = Dispatcher
export const BaseComponent = BaseComponent2
export const ApolloClient = Apollo
export const MultiSelect = Ms
export const Textbox = Tb
export const URL = URL2
export const History = History2
export const Modal = Modal2
export const BufferObject = bufferObject
export const Request = Request2
export const SubmitButton = SubmitButton2
export const Select = Select2
export const Helpers = {
  objectParser
}